
import React, { ReactNode, useState, useEffect } from 'react';

import axios from 'axios';


// @ts-ignore: allow importing CSS without a type declaration

import '../Tracking/PacifixTracking.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import Logo from '../Logo/Jaimarutilogo.png';

import ShreRamji from '../Logo/Express_logo.png';

import Swal from "sweetalert2";

<link rel="stylesheet"

    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.2/css/all.min.css"></link>

interface StatusEntry {

    Destination_name: string;

    LocationName: string;

    Status: string;

    DelvDt: string;

    DelvTime: string;

}

interface TrackingRecord {

    DocketNo: string;

    BookDate: string;

    DelvDT: string;

    ExptDateOfDelvDt: string;

    OriginCity: string;

    DestinationCity: string;

    Consignee_Name: string;

    Status: string;

    DelvTime: string | null;

    VendorAwbNo: string;

    Vendor_Name: string;

    ActualWt: number;

    ChargedWt: number;

    Qty: number;

    EwayBill: string;

    InvoiceNo: string;

    Mode_Code: string;

    Consignee_Mob: string;

    Consignee_Pin: string;

    RecvName: string | null;

    ReceivedMo: string;

    Recvremark: string | null;

    DrsDate: string | null;

    DrsNo: string | null;

    Employee_code: string | null;

    Employee_Mobile: string | null;

    Area: string | null;

    VehicleNo: string | null;

    Location_Code: string | null;

    Manifest_No: string | null;

    Manifest_Dt: string | null;

    From_Dest: string | null;

    ManifestDestination: string | null;

    ImageLink?: string;

    StatusEntry: StatusEntry[];

}

type BrowserSpeechRecognition = {
    lang: string;
    continuous: boolean;
    interimResults: boolean;
    start(): void;
    stop(): void;
    onresult: ((event: any) => void) | null;
    onerror: ((event: any) => void) | null;
    onend: (() => void) | null;
};

declare global {
    interface Window {
        SpeechRecognition?: new () => BrowserSpeechRecognition;
        webkitSpeechRecognition?: new () => BrowserSpeechRecognition;
    }
}

const ExpressWorldTracking = (): JSX.Element => {

    const [searchValue, setSearchValue] = useState('');

    const [trackingData, setTrackingData] = useState<TrackingRecord | null>(null);

    const [skyNetData, setSkyNetData] = useState<any>(null);

    const [showPod, setShowPod] = useState(false);

    const [showModal, setShowModal] = useState(false);

    const [error, setError] = useState('');
    const [isListening, setIsListening] = useState(false);
    const [isSpeaking, setIsSpeaking] = useState(false);

    useEffect(() => {

        const toggleButton =
            document.getElementById("toggleButton");

        const buttonContainer =
            document.getElementById("buttonContainer");

        const whatsappMobileButton =
            document.getElementById("whatsappMobile");

        const whatsappWebButton =
            document.getElementById("whatsappWeb");

        const callButton =
            document.querySelector(".callbackfuncation");


        if (!toggleButton || !buttonContainer) return;


        /* =====================================================
           TOGGLE OPEN / CLOSE
        ===================================================== */

        const handleToggle = () => {

            buttonContainer.classList.toggle("hidden");

        };


        toggleButton.addEventListener(
            "click",
            handleToggle
        );


        /* =====================================================
           DEVICE DETECTION
        ===================================================== */

        const isMobile =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
                .test(navigator.userAgent);


        if (isMobile) {

            if (whatsappWebButton) {

                (whatsappWebButton as HTMLElement)
                    .style.display = "none";

            }

        } else {

            if (whatsappMobileButton) {

                (whatsappMobileButton as HTMLElement)
                    .style.display = "none";

            }

        }


        /* =====================================================
           WHATSAPP MOBILE
        ===================================================== */

        const handleWhatsappMobile = (event: Event) => {

            event.preventDefault();

            window.open(
                "https://wa.me/919975350136",
                "_blank"
            );

        };


        whatsappMobileButton?.addEventListener(
            "click",
            handleWhatsappMobile
        );
        /* =====================================================
           WHATSAPP WEB
        ===================================================== */

        const handleWhatsappWeb = (event: Event) => {

            event.preventDefault();

            window.open(
                "https://web.whatsapp.com/send?phone=919975350136&text=Hello%20there!",
                "_blank"
            );

        };
        whatsappWebButton?.addEventListener(
            "click",
            handleWhatsappWeb
        );
        /* =====================================================
           CALL
        ===================================================== */
        const handleCall = (event: Event) => {

            event.preventDefault();

            window.location.href =
                "tel:+919888880259";

        };

        callButton?.addEventListener(
            "click",
            handleCall
        );


        /* =====================================================
           CLEANUP
        ===================================================== */

        return () => {

            toggleButton.removeEventListener(
                "click",
                handleToggle
            );

            whatsappMobileButton?.removeEventListener(
                "click",
                handleWhatsappMobile
            );

            whatsappWebButton?.removeEventListener(
                "click",
                handleWhatsappWeb
            );

            callButton?.removeEventListener(
                "click",
                handleCall
            );

        };

    }, []);

    // 👆 YAHAN TAK PASTE KARO

    const handleButtonClick = () => {

        setShowPod(!showPod);

    };

    // Speak ONLY the current shipment status in English + Hindi.

const speakTrackingData = (tracking: TrackingRecord) => {
    if (!("speechSynthesis" in window)) return;

    // Stop any previous voice
    window.speechSynthesis.cancel();

    // =====================================================
    // NORMALIZE STATUS
    // =====================================================
    const normalizeStatus = (value: any) => {
        return String(value || "")
            .trim()
            .toLowerCase()
            .replace(/[_-]+/g, " ")
            .replace(/\s+/g, " ")
            .trim();
    };

    // =====================================================
    // HISTORY
    // =====================================================
    const history = Array.isArray(tracking.StatusEntry)
        ? tracking.StatusEntry
        : [];

    // =====================================================
    // FIND CURRENT STATUS FROM STATUS HISTORY
    // =====================================================
    let currentStatus = "";
    let currentEntry: StatusEntry | null = null;

    /*
     * Priority:
     *
     * 1. Delivered
     * 2. Out For Delivery
     * 3. Other latest status
     *
     * This prevents API message such as:
     * "We are experiencing transit delays..."
     * from being spoken.
     */

    const deliveredEntry = [...history]
        .reverse()
        .find(
            (item) =>
                normalizeStatus(item.Status) === "delivered"
        );

    const outForDeliveryEntry = [...history]
        .reverse()
        .find(
            (item) =>
                normalizeStatus(item.Status) ===
                "out for delivery"
        );

    if (deliveredEntry) {

        currentStatus = "delivered";
        currentEntry = deliveredEntry;

    } else if (outForDeliveryEntry) {

        currentStatus = "out for delivery";
        currentEntry = outForDeliveryEntry;

    } else if (history.length > 0) {

        const lastEntry =
            history[history.length - 1];

        currentStatus =
            normalizeStatus(lastEntry.Status);

        currentEntry = lastEntry;
    }

    // =====================================================
    // FALLBACK
    // =====================================================
    if (!currentStatus) {

        const apiStatus =
            normalizeStatus(tracking.Status);

        /*
         * IMPORTANT:
         * Long API message ko voice mein nahi bolna.
         */

        if (
            apiStatus.includes("delivered")
        ) {
            currentStatus = "delivered";
        } else if (
            apiStatus.includes("out for delivery")
        ) {
            currentStatus = "out for delivery";
        } else if (
            apiStatus.includes("in transit")
        ) {
            currentStatus = "in transit";
        } else if (
            apiStatus.includes("booked")
        ) {
            currentStatus = "booked";
        } else if (
            apiStatus.includes("picked up")
        ) {
            currentStatus = "picked up";
        } else if (
            apiStatus.includes("dispatched")
        ) {
            currentStatus = "dispatched";
        } else if (
            apiStatus.includes("arrived")
        ) {
            currentStatus = "arrived";
        } else {

            // NEVER speak long API message
            currentStatus = "in transit";
        }
    }

    // =====================================================
    // DATE FORMAT
    // =====================================================
    const formatDate = (
        value: string | null | undefined
    ) => {

        if (!value) return "";

        const str =
            String(value).trim();

        const match =
            str.match(
                /^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/
            );

        if (!match) return str;

        const day =
            Number(match[1]);

        const month =
            Number(match[2]);

        const year =
            Number(match[3]);

        const months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];

        return `${day} ${months[month - 1]} ${year}`;
    };

    // =====================================================
    // HINDI DATE
    // =====================================================
    const formatHindiDate = (
        value: string | null | undefined
    ) => {

        if (!value) return "";

        const str =
            String(value).trim();

        const match =
            str.match(
                /^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/
            );

        if (!match) return str;

        const day =
            Number(match[1]);

        const month =
            Number(match[2]);

        const year =
            Number(match[3]);

        const months = [
            "जनवरी",
            "फरवरी",
            "मार्च",
            "अप्रैल",
            "मई",
            "जून",
            "जुलाई",
            "अगस्त",
            "सितंबर",
            "अक्टूबर",
            "नवंबर",
            "दिसंबर"
        ];

        return `${day} ${months[month - 1]} ${year}`;
    };

    // =====================================================
    // LOCATION
    // =====================================================
    let currentLocation = "";

    if (currentEntry) {

        currentLocation =
            String(
                currentEntry.LocationName ||
                currentEntry.Destination_name ||
                ""
            ).trim();
    }

    // =====================================================
    // FALLBACK LOCATION
    // =====================================================
    if (!currentLocation && history.length > 0) {

        const lastEntry =
            history[history.length - 1];

        currentLocation =
            String(
                lastEntry.LocationName ||
                lastEntry.Destination_name ||
                ""
            ).trim();
    }

    // =====================================================
    // DATES
    // =====================================================
    const bookingDate =
        formatDate(tracking.BookDate);

    const bookingDateHindi =
        formatHindiDate(tracking.BookDate);

    /*
     * Delivered date:
     *
     * First priority = current Delivered history date
     * Second priority = tracking.DelvDT
     */

    let deliveredDateValue = "";

    if (
        currentStatus === "delivered" &&
        currentEntry?.DelvDt
    ) {
        deliveredDateValue =
            currentEntry.DelvDt;
    } else {
        deliveredDateValue =
            tracking.DelvDT;
    }

    const deliveredDate =
        formatDate(deliveredDateValue);

    const deliveredDateHindi =
        formatHindiDate(deliveredDateValue);

    // =====================================================
    // DESTINATION
    // =====================================================
    const destination =
        String(
            tracking.DestinationCity || ""
        ).trim();

    // =====================================================
    // VOICE TEXT
    // =====================================================
    let englishText = "";
    let hindiText = "";

    // =====================================================
    // DELIVERED
    // =====================================================
    if (currentStatus === "delivered") {

        englishText =
            "Shipment has been delivered.";

        hindiText =
            "शिपमेंट डिलीवर हो गया है।";

        if (deliveredDate) {

            englishText +=
                ` It was delivered on ${deliveredDate}.`;

            hindiText +=
                ` यह ${deliveredDateHindi} को डिलीवर हुआ है।`;
        }

        if (currentLocation) {

            englishText +=
                ` Delivered location is ${currentLocation}.`;

            hindiText +=
                ` डिलीवरी लोकेशन ${currentLocation} है।`;
        }
    }

    // =====================================================
    // OUT FOR DELIVERY
    // =====================================================
    else if (
        currentStatus === "out for delivery"
    ) {

        englishText =
            "Shipment is out for delivery.";

        hindiText =
            "शिपमेंट डिलीवरी के लिए निकल गया है।";

        if (currentLocation) {

            englishText +=
                ` Current location is ${currentLocation}.`;

            hindiText +=
                ` वर्तमान लोकेशन ${currentLocation} है।`;
        }
    }

    // =====================================================
    // BOOKED
    // =====================================================
    else if (
        currentStatus === "booked" ||
        currentStatus === "shipment booked"
    ) {

        englishText =
            "Shipment has been booked.";

        hindiText =
            "शिपमेंट बुक हो गया है।";

        if (bookingDate) {

            englishText +=
                ` Booking date is ${bookingDate}.`;

            hindiText +=
                ` बुकिंग डेट ${bookingDateHindi} है।`;
        }

        if (destination) {

            englishText +=
                ` Destination is ${destination}.`;

            hindiText +=
                ` डेस्टिनेशन ${destination} है।`;
        }
    }

    // =====================================================
    // IN TRANSIT
    // =====================================================
    else if (
        currentStatus === "in transit"
    ) {

        englishText =
            "Shipment is in transit.";

        hindiText =
            "शिपमेंट अभी रास्ते में है।";

        if (currentLocation) {

            englishText +=
                ` Current location is ${currentLocation}.`;

            hindiText +=
                ` वर्तमान लोकेशन ${currentLocation} है।`;
        }
    }

    // =====================================================
    // PICKED UP
    // =====================================================
    else if (
        currentStatus === "picked up" ||
        currentStatus === "shipment picked up"
    ) {

        englishText =
            "Shipment has been picked up.";

        hindiText =
            "शिपमेंट पिकअप हो गया है।";

        if (currentLocation) {

            englishText +=
                ` Current location is ${currentLocation}.`;

            hindiText +=
                ` वर्तमान लोकेशन ${currentLocation} है।`;
        }
    }

    // =====================================================
    // DISPATCHED
    // =====================================================
    else if (
        currentStatus === "dispatched" ||
        currentStatus === "shipment dispatched"
    ) {

        englishText =
            "Shipment has been dispatched.";

        hindiText =
            "शिपमेंट डिस्पैच हो गया है।";

        if (currentLocation) {

            englishText +=
                ` Current location is ${currentLocation}.`;

            hindiText +=
                ` वर्तमान लोकेशन ${currentLocation} है।`;
        }
    }

    // =====================================================
    // ARRIVED
    // =====================================================
    else if (
        currentStatus === "arrived" ||
        currentStatus === "shipment arrived"
    ) {

        englishText =
            "Shipment has arrived.";

        hindiText =
            "शिपमेंट पहुँच गया है।";

        if (currentLocation) {

            englishText +=
                ` Current location is ${currentLocation}.`;

            hindiText +=
                ` वर्तमान लोकेशन ${currentLocation} है।`;
        }
    }

    // =====================================================
    // DEFAULT
    // =====================================================
    else {

        englishText =
            "Shipment is currently in transit.";

        hindiText =
            "शिपमेंट अभी रास्ते में है।";

        if (currentLocation) {

            englishText +=
                ` Current location is ${currentLocation}.`;

            hindiText +=
                ` वर्तमान लोकेशन ${currentLocation} है।`;
        }
    }

    // =====================================================
    // DEBUG
    // =====================================================
    console.log(
        "VOICE API STATUS:",
        tracking.Status
    );

    console.log(
        "VOICE CURRENT STATUS:",
        currentStatus
    );

    console.log(
        "VOICE BOOKING DATE:",
        tracking.BookDate
    );

    console.log(
        "VOICE DELIVERED DATE:",
        deliveredDateValue
    );

    console.log(
        "VOICE CURRENT LOCATION:",
        currentLocation
    );

    console.log(
        "VOICE ENGLISH:",
        englishText
    );

    console.log(
        "VOICE HINDI:",
        hindiText
    );

    // =====================================================
    // ENGLISH VOICE
    // =====================================================
    const englishVoice =
        new SpeechSynthesisUtterance(
            englishText
        );

    englishVoice.lang = "en-IN";
    englishVoice.rate = 0.9;
    englishVoice.pitch = 1;
    englishVoice.volume = 1;

    // =====================================================
    // HINDI VOICE
    // =====================================================
    const hindiVoice =
        new SpeechSynthesisUtterance(
            hindiText
        );

    hindiVoice.lang = "hi-IN";
    hindiVoice.rate = 0.9;
    hindiVoice.pitch = 1;
    hindiVoice.volume = 1;

    setIsSpeaking(true);

    hindiVoice.onend = () => {
        setIsSpeaking(false);
    };

    hindiVoice.onerror = () => {
        setIsSpeaking(false);
    };

    // =====================================================
    // SPEAK
    // =====================================================
    window.speechSynthesis.cancel();

    setTimeout(() => {

        window.speechSynthesis.speak(
            englishVoice
        );

        setTimeout(() => {

            window.speechSynthesis.speak(
                hindiVoice
            );

        }, 150);

    }, 100);
};
    

    const stopVoice = () => {
        if ("speechSynthesis" in window) {
            window.speechSynthesis.cancel();
        }
        setIsSpeaking(false);
    };

    const startVoiceTracking = () => {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

        if (!SpeechRecognition) {
            Swal.fire({
                icon: "error",
                title: "Voice Not Supported",
                text: "Please use Google Chrome or Microsoft Edge for voice tracking."
            });
            return;
        }

        if (isListening) return;

        const recognition = new SpeechRecognition();
        recognition.lang = "en-IN";
        recognition.continuous = false;
        recognition.interimResults = false;
        setIsListening(true);

        recognition.onresult = (event) => {
            const spokenText = String(event.results?.[0]?.[0]?.transcript || "").trim().toLowerCase();
            console.log("User said:", spokenText);

            const numberWords: Record<string, string> = {
                zero: "0", oh: "0", o: "0",
                one: "1",
                two: "2", to: "2", too: "2",
                three: "3", four: "4", five: "5",
                six: "6", seven: "7", eight: "8", nine: "9"
            };

            const docketNo = spokenText
                .split(/\s+/)
                .map(word => numberWords[word] ?? word)
                .join("")
                .replace(/\D/g, "");

            console.log("Docket No:", docketNo);

            if (!docketNo) {
                setIsListening(false);
                Swal.fire({
                    icon: "warning",
                    title: "Docket Number Not Detected",
                    text: "Please speak the docket number again."
                });
                return;
            }

            setSearchValue(docketNo);
            setIsListening(false);
            fetchData(docketNo);
        };

        recognition.onerror = (event) => {
            console.error("Speech recognition error:", event);
            setIsListening(false);
            Swal.fire({
                icon: "error",
                title: "Voice Error",
                text: "Docket number properly detect nahi hua. Please try again."
            });
        };

        recognition.onend = () => setIsListening(false);

        try {
            recognition.start();
        } catch (err) {
            console.error("Unable to start speech recognition:", err);
            setIsListening(false);
        }
    };

    
const fetchData = async (docketNo?: string) => {
    try {
        const trackingNumber = (docketNo || searchValue).trim();

        if (!trackingNumber) {
            Swal.fire({
                icon: "warning",
                title: "Enter Tracking Number",
                text: "Please enter Docket No or Vendor AWB No.",
            });
            return;
        }

        const params = new URLSearchParams({
            DocketNo: trackingNumber,
            VendorAwbno: trackingNumber,
        });

        const url =
            `https://erp.futureinfosys.in/Expwwc/Master/getTrackingData?${params.toString()}`;

        const res = await axios.get(url);

        if (
            res.data.status === 1 &&
            Array.isArray(res.data.Data) &&
            res.data.Data.length > 0
        ) {
            const tracking = res.data.Data[0];

            setTrackingData(tracking);
            setSearchValue("");
            setError("");

            Swal.fire({
                icon: "success",
                title: "Tracking Found",
                timer: 1200,
                showConfirmButton: false,
            });

            speakTrackingData(tracking);
        } else {
            setTrackingData(null);
            window.speechSynthesis?.cancel();
            setIsSpeaking(false);

            Swal.fire({
                icon: "warning",
                title: "No Data Found",
                text: "Please check your Docket No or Vendor AWB No.",
            });
        }
    } catch (error) {
        console.error(error);
        window.speechSynthesis?.cancel();
        setIsSpeaking(false);

        Swal.fire({
            icon: "error",
            title: "Error Fetching Data",
            text: "Unable to fetch tracking details.",
        });
    }
};


    const downloadPod = async () => {

        if (!trackingData?.ImageLink) return;

        try {

            const response = await fetch(trackingData.ImageLink);

            if (!response.ok) {

                throw new Error("Image not found");

            }

            const blob = await response.blob();

            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement("a");

            link.href = blobUrl;

            const fileName =

                trackingData.ImageLink.split("/").pop() ||

                `POD_${trackingData.DocketNo}.png`;

            link.download = fileName;

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);

            window.URL.revokeObjectURL(blobUrl);

        } catch (err) {

            console.error(err);

            Swal.fire({

                icon: "error",

                title: "Download Failed",

                text: "Unable to download POD Image.",

            });

        }

    };

    const getTrackingUrl = (

        awb: string,

        vendor?: string,

        pin?: string

    ) => {

        if (!awb) return "#";

        const v = (vendor || "")

            .toUpperCase()

            .trim()

            .replace(/\s+/g, " ");

        console.log("Vendor =", v);

        console.log("AWB =", awb);

        // ================= INTERNATIONAL =================

        if (v.includes("DHL")) {

            return `https://www.dhl.com/in-en/home/tracking.html?tracking-id=${awb}&submit=1`;

        }

        if (v.includes("DPD")) {

            return `https://track.dpd.co.uk/?reference=${awb}`;

        }

        if (v.includes("PUROLATOR")) {

            return `https://www.purolator.com/en/shipping/tracker?pin=${awb}`;

        }

        if (v.includes("FEDEX")) {

            return `https://www.fedex.com/fedextrack/?trknbr=${awb}`;

        }

        if (v.includes("UPS")) {

            return `https://www.ups.com/track?tracknum=${awb}`;

        }

        if (v.includes("SKYNET")) {

            return "https://www.skynetww.com/track";

        }

        if (v.includes("ARAMEX")) {

            return `https://www.aramex.com/track/results?ShipmentNumber=${awb}`;

        }

        if (v.includes("COURIERSPLEASE") || v.includes("COURIERS PLEASE")) {

            return `https://www.couriersplease.com.au/tools-track?no=${awb}`;

        }

        if (v.includes("USPS")) {

            return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${awb}`;

        }

        if (v.includes("CANADA POST")) {

            return `https://www.canadapost-postescanada.ca/track-reperage/en#/search?searchFor=${awb}`;

        }

        if (v.includes("ROYAL MAIL")) {

            return `https://www.royalmail.com/track-your-item#/tracking-results/${awb}`;

        }

        if (v.includes("TNT")) {

            return `https://www.tnt.com/express/en_in/site/shipping-tools/tracking.html`;

        }

        // ================= INDIA =================

        // if (v.includes("SKYNET")) {

        //     return `https://skynetww.com/track/${awb}`;

        // }

        if (v.includes("SKYNET")) {

            return "https://www.skynetww.com/track";

        }

        if (v.includes("DTDC")) {

            return `https://www.dtdc.in/tracking/tracking_results.asp?strCnno=${awb}`;

        }

        if (v.includes("BLUE DART") || v.includes("BLUEDART")) {

            return `https://www.bluedart.com/tracking?tracking_number=${awb}`;

        }

        if (v.includes("DELHIVERY")) {

            return `https://www.delhivery.com/track/package/${awb}`;

        }

        if (v.includes("XPRESSBEES")) {

            return `https://www.xpressbees.com/shipment-tracking?awb=${awb}`;

        }

        if (v.includes("ECOM")) {

            return `https://ecomexpress.in/tracking/?awb_field=${awb}`;

        }

        if (v.includes("EKART")) {

            return `https://ekartlogistics.com/shipmenttrack/${awb}`;

        }

        if (v.includes("SHADOWFAX")) {

            return `https://www.shadowfax.in/`;

        }

        if (v.includes("GATI")) {

            return `https://www.gati.com/tracking`;

        }

        if (v.includes("TCI")) {

            return `https://www.tciexpress.in/trackingdocket.aspx`;

        }

        if (v.includes("TRACKON")) {

            return `https://trackon.in/Tracking.aspx`;

        }

        if (v.includes("PROFESSIONAL")) {

            return `https://www.tpcindia.com/Tracking.aspx`;

        }

        if (v.includes("SAFEXPRESS")) {

            return `https://www.safexpress.com/track-shipment`;

        }

        if (v.includes("FIRST FLIGHT")) {

            return `https://www.firstflight.net/track`;

        }

        if (v.includes("INDIA POST") || v.includes("SPEED POST")) {

            return `https://www.indiapost.gov.in/_layouts/15/dop.portal.tracking/trackconsignment.aspx`;

        }

        if (v.includes("OVERNITE")) {

            return `https://www.overnitenet.com/Tracking.aspx`;

        }

        if (v.includes("SHREE MARUTI")) {

            return `https://www.shreemaruti.com/track-your-shipment`;

        }

        if (v.includes("MADHUR")) {

            return `https://www.madhurcouriers.in/track`;

        }

        if (v.includes("MARUTI")) {

            return `https://www.maruticourier.com/track-your-shipment`;

        }

        return "#";

    };

    return (

        <>

            <header className="navbarheader-fluid">

                {/* =====================================================
        TOP BAR
    ===================================================== */}

                <div className="top-bar">
                    Welcome to Express Worldwide Courier & Cargo | +91 9975350136 - corporate@expwwc.com
                </div>


                {/* =====================================================
        DESKTOP NAVBAR
    ===================================================== */}

                <div
                    className="navbar-container"
                    style={{ margin: "50px" }}
                >

                    {/* LOGO */}

                    <div className="navbar-logo">

                        <img
                            src={ShreRamji}
                            alt="Express Worldwide Courier & Cargo"
                        />

                    </div>


                    {/* DESKTOP MENU */}

                    <nav className="navbar-links">

                        <a href="https://expwwc.com/">
                            Home
                        </a>

                        <a href="https://expwwc.com/about.html">
                            About Us
                        </a>

                        <a href="https://expwwc.com/our-history.html">
                            Services
                        </a>

                        <a href="https://expwwc.com/Document.html">
                            Document
                        </a>

                        <a href="https://expwwc.com/contact.html">
                            Contact
                        </a>

                        <a href="https://expwwc.com/NewLogin">
                            Branch Login
                        </a>

                    </nav>

                </div>


                {/* =====================================================
        MOBILE NAVBAR
    ===================================================== */}

                <nav className="mobile-navbar">

                    <div className="mobile-navbar-inner">


                        {/* MENU BUTTON */}

                        <button
                            className="mobile-menu-button"
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasNavbar"
                            aria-controls="offcanvasNavbar"
                            aria-label="Open navigation menu"
                        >

                            <span className="navbar-toggler-icon"></span>

                        </button>


                        {/* MOBILE LOGO */}

                        <a
                            className="mobile-navbar-logo"
                            href="https://expwwc.com/"
                            aria-label="Express Worldwide Courier & Cargo"
                        >

                            <img
                                src={ShreRamji}
                                alt="Express Worldwide Courier & Cargo"
                            />

                        </a>


                        {/* =================================================
                MOBILE OFFCANVAS MENU
            ================================================= */}

                        <div
                            className="offcanvas offcanvas-start mobile-offcanvas"
                            id="offcanvasNavbar"
                            tabIndex={-1}
                            aria-labelledby="offcanvasNavbarLabel"
                        >

                            {/* MENU HEADER */}

                            <div className="offcanvas-header mobile-offcanvas-header">

                                <h5
                                    className="offcanvas-title"
                                    id="offcanvasNavbarLabel"
                                >
                                    Menu
                                </h5>

                                <button
                                    type="button"
                                    className="btn-close mobile-menu-close"
                                    data-bs-dismiss="offcanvas"
                                    aria-label="Close"
                                >
                                </button>

                            </div>


                            {/* MENU BODY */}

                            <div className="offcanvas-body mobile-offcanvas-body">

                                <ul className="mobile-menu-list">

                                    <li>
                                        <a href="https://expwwc.com/">
                                            <span>Home</span>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://expwwc.com/about.html">
                                            <span>About Us</span>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://expwwc.com/our-history.html">
                                            <span>Services</span>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://expwwc.com/NewLogin">
                                            <span>Branch Login</span>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://expwwc.com/Document.html">
                                            <span>Document</span>
                                        </a>
                                    </li>

                                    <li>
                                        <a href="https://expwwc.com/contact.html">
                                            <span>Contact</span>
                                        </a>
                                    </li>

                                </ul>

                            </div>

                        </div>

                    </div>

                </nav>

            </header>

            <div className="tracking-container">
                <div className="tracking-wrapper w-full bg-slate-50 px-4 py-8 sm:px-6 lg:px-8">
                    <div className="tracking-card">

                        <div className="tracking-header">
                            <div>
                                <div className="tracking-mini-title">
                                    <i className="fa-solid fa-location-crosshairs"></i>
                                    EXPRESS WOLRDWIDE COURIER AND CARGO PVT.LTD
                                </div>

                                <h2>Shipment Tracking</h2>

                                <p>
                                    Enter an AWB number or speak the docket number to track your shipment.
                                </p>
                            </div>

                            <div className="tracking-ready">
                                <span></span>
                                Tracking Ready
                            </div>
                        </div>


                        <div className="tracking-body">

                            <label className="tracking-label">
                                Docket / AWB / Reference No
                            </label>

                            <div className="tracking-input-box">

                                <span className="tracking-input-icon">
                                    <i className="fa-solid fa-box"></i>
                                </span>

                                <input
                                    type="text"
                                    value={searchValue}
                                    onChange={(e) => setSearchValue(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            fetchData();
                                        }
                                    }}
                                    placeholder="Enter AWB Number or Reference No"
                                />

                            </div>


                            <div className="tracking-actions">

                                {/* Track */}
                                <button
                                    className="tracking-btn tracking-btn-primary"
                                    onClick={() => fetchData()}
                                    type="button"
                                >
                                    <i className="fa-solid fa-magnifying-glass"></i>
                                    <span>Track Shipment</span>
                                    <i className="fa-solid fa-arrow-right tracking-arrow"></i>
                                </button>


                                {/* Speak */}
                                <button
                                    className={`tracking-btn tracking-btn-voice ${isListening ? "voice-listening" : ""
                                        }`}
                                    onClick={startVoiceTracking}
                                    type="button"
                                    disabled={isListening}
                                >
                                    <span className="voice-icon">
                                        <i className={`fa-solid ${isListening
                                            ? "fa-circle-notch fa-spin"
                                            : "fa-microphone"
                                            }`}></i>
                                    </span>

                                    <span>
                                        {isListening ? "Listening..." : "Speak Docket"}
                                    </span>
                                </button>


                                {/* Stop */}
                                <button
                                    className={`tracking-btn tracking-btn-stop ${isSpeaking ? "voice-active" : ""
                                        }`}
                                    onClick={stopVoice}
                                    type="button"
                                    disabled={!isSpeaking}
                                >
                                    <i className="fa-solid fa-volume-xmark"></i>
                                    <span>Stop Voice</span>
                                </button>


                                {/* Clear */}
                                <button
                                    className="tracking-btn tracking-btn-clear"
                                    onClick={() => {
                                        setSearchValue("");
                                    }}
                                    type="button"
                                >
                                    <i className="fa-solid fa-rotate-left"></i>
                                    <span>Clear</span>
                                </button>

                            </div>


                            <div className="tracking-footer">
                                <i className="fa-solid fa-shield-halved"></i>

                                <span>
                                    Fast tracking & voice assistance powered by your browser.
                                </span>

                                <b>English & Hindi</b>
                            </div>

                        </div>

                    </div>

                    {/* Floating Contact Buttons */}

                  

                </div>

                {error && <p className="error">{error}</p>}

                {trackingData && (

                    <div className="result-section">

                        <div className="grid">

                            {/* LEFT */}

                            <div className="card">

                                <div className="card-header">Shipment Details</div>

                                <table className="shipment-table">

                                    <tbody>

                                        <tr>

                                            <td className="label">Docket No.</td>

                                            <td>{trackingData?.DocketNo}</td>

                                        </tr>

                                        <tr>

                                            <td className="label">Booking Date</td>

                                            <td>{trackingData?.BookDate}</td>

                                        </tr>

                                        <tr>

                                            <td className="label">Consignee</td>

                                            <td>{trackingData?.Consignee_Name}</td>

                                        </tr>

                                        <tr>

                                            <td className="label">Origin</td>

                                            <td>{trackingData?.OriginCity}</td>

                                        </tr>

                                        <tr>

                                            <td className="label">Destination</td>

                                            <td>{trackingData?.DestinationCity}</td>

                                        </tr>

                                        {/* <tr>

                                            <td className="label">Vendor AWB</td>

                                            <td>{trackingData?.VendorAwbNo}</td>

                                        </tr> */}

                                        <tr>

                                            <td className="label">Vendor</td>

                                            <td>

                                                <strong>{trackingData?.Vendor_Name || "N/A"}</strong>

                                                <br />

                                                {trackingData?.VendorAwbNo ? (

                                                    <a

                                                        href={getTrackingUrl(

                                                            trackingData?.VendorAwbNo,

                                                            trackingData?.Vendor_Name,

                                                            trackingData?.Consignee_Pin

                                                        )}

                                                        target="_blank"

                                                        rel="noopener noreferrer"

                                                    >

                                                        {trackingData?.VendorAwbNo}

                                                    </a>

                                                ) : (

                                                    "-"

                                                )}

                                            </td>

                                        </tr>

                                        <tr>

                                            <td className="label">Status</td>

                                            <td>{trackingData?.Status}</td>

                                        </tr>

                                        <tr>

                                            <td className="label">Qty</td>

                                            <td>{trackingData?.Qty}</td>

                                        </tr>

                                        <tr>

                                            <td className="label">RecvName</td>

                                            <td>{trackingData?.RecvName}</td>

                                        </tr>

                                        <tr>

                                            <td className="label">Mode</td>

                                            <td>{trackingData?.Mode_Code}</td>

                                        </tr>

                                        <tr>

                                            <td className="label">POD Image</td>

                                            <td>

                                                {trackingData?.ImageLink ? (

                                                    <button

                                                        className="btn btn-primary btn-sm"

                                                        onClick={() => setShowPod(true)}

                                                    >

                                                        View POD

                                                    </button>

                                                ) : (

                                                    <span>No POD Available</span>

                                                )}

                                            </td>

                                        </tr>

                                    </tbody>

                                </table>

                                {showPod && (

                                    <div

                                        style={{

                                            position: "fixed",

                                            top: 0,

                                            left: 0,

                                            width: "100%",

                                            height: "100%",

                                            background: "rgba(0,0,0,0.8)",

                                            display: "flex",

                                            justifyContent: "center",

                                            alignItems: "center",

                                            zIndex: 9999,

                                        }}

                                    >

                                        <div

                                            style={{

                                                background: "#fff",

                                                padding: "20px",

                                                borderRadius: "10px",

                                                width: "90%",

                                                maxWidth: "900px",

                                                maxHeight: "90vh",

                                                overflow: "auto",

                                                position: "relative",

                                            }}

                                        >

                                            {/* Header */}

                                            <div

                                                style={{

                                                    display: "flex",

                                                    justifyContent: "space-between",

                                                    marginBottom: "15px"

                                                }}

                                            >

                                                <h4>POD Image</h4>

                                                <div>

                                                    <button

                                                        className="btn btn-success"

                                                        style={{ marginRight: "10px" }}

                                                        onClick={downloadPod}

                                                    >

                                                        ⬇ Download

                                                    </button>

                                                    <button

                                                        className="btn btn-danger"

                                                        onClick={() => setShowPod(false)}

                                                    >

                                                        ✖ Close

                                                    </button>

                                                </div>

                                            </div>

                                            {/* Image */}

                                            <img

                                                src={trackingData?.ImageLink}

                                                alt="POD"

                                                style={{

                                                    width: "100%",

                                                    maxHeight: "75vh",

                                                    objectFit: "contain",

                                                    border: "1px solid #ddd",

                                                    borderRadius: "8px"

                                                }}

                                            />

                                        </div>

                                    </div>

                                )}

                            </div>

                            {/* RIGHT */}

                            <div className="card">

                                <div className="card-header">Shipping History</div>

                                <table>

                                    <thead>

                                        <tr>

                                            <th>Date</th>

                                            <th>Time</th>

                                            <th>Location</th>

                                            <th>Status</th>

                                        </tr>

                                    </thead>

                                    <tbody>

                                        {trackingData?.StatusEntry?.length > 0 ? (

                                            trackingData.StatusEntry.map((item, i) => (

                                                <tr key={i}>

                                                    <td>{item.DelvDt}</td>

                                                    <td>{item.DelvTime}</td>

                                                    <td>{item.Destination_name}</td>

                                                    <td>{item.Status}</td>

                                                </tr>

                                            ))

                                        ) : (

                                            <tr>

                                                <td colSpan={4}>No Tracking History</td>

                                            </tr>

                                        )}

                                    </tbody>

                                </table>

                                {skyNetData?.shipmentHistory?.length > 0 && (

                                    <div className="card mt-4">

                                        <div className="card-header">

                                            🌍 SkyNet Shipment History

                                        </div>

                                        <table className="table table-bordered">

                                            <thead>

                                                <tr>

                                                    <th>Date</th>

                                                    <th>Time</th>

                                                    <th>Status</th>

                                                    <th>Details</th>

                                                    <th>Location</th>

                                                </tr>

                                            </thead>

                                            <tbody>

                                                {skyNetData.shipmentHistory.map((item: any, index: number) => (

                                                    <tr key={index}>

                                                        <td>{item.date}</td>

                                                        <td>{item.time}</td>

                                                        <td>

                                                            <span className="badge bg-primary">

                                                                {item.shipmentStatus}

                                                            </span>

                                                        </td>

                                                        <td>{item.shipmentDetails}</td>

                                                        <td>{item.location}</td>

                                                    </tr>

                                                ))}

                                            </tbody>

                                        </table>

                                    </div>

                                )}

                            </div>

                        </div>

                    </div>

                )}

            


          
             <div className="floating-contact">

                        <div id="buttonContainer" className="hidden">

                            {/* Call */}

                            <a

                                href="tel:+919888880259"

                                className="callbackfuncation"

                                target="_blank"

                                rel="noreferrer"

                            >

                                <i className="fas fa-phone-alt"></i>

                            </a>

                            {/* WhatsApp Mobile */}

                            <a

                                href="https://wa.me/919975350136"

                                className="btn-whatsapp-pulse whatsapp"

                                id="whatsappMobile"

                                target="_blank"

                                rel="noopener noreferrer"

                            >

                                <i className="fab fa-whatsapp"></i>

                            </a>

                            {/* WhatsApp Web */}

                            <a

                                href="https://web.whatsapp.com/send?phone=919975350136&text=Hello%20there!"

                                className="btn-whatsapp-pulse whatsapp"

                                id="whatsappWeb"

                                target="_blank"

                                rel="noopener noreferrer"

                            >

                                <i className="fab fa-whatsapp"></i>

                            </a>

                        </div>

                        <button id="toggleButton" className="animated-button">

                            <i className="fas fa-comments"></i>

                        </button>

                    </div>


            

                <footer className="footer-light">

                    <div className="footer-container-fluid">

                        <div className="footer-grid">

                            {/* COLUMN 1 */}

                            <div className="footer-box">

                                <h3>Express Worldwide Courier & Cargo Pvt.Ltd</h3>

                                <h4>Mumbai (Head Office)</h4>

                                <p>

                                    As a privately owned company, we are a highly focused and capable logistics specialist with a strong global presence and extensive agency representation across most countries. At <br /> <b>Express Worldwide Courier & Cargo Pvt . Ltd</b> WORLD WIDE LOGISTICS, client satisfaction is our top priority. We are committed to delivering reliable, efficient, and tailored solutions every time.

                                </p>

                            </div>

                            {/* COLUMN 2 */}

                            <div className="footer-box"> 

                                <h3>Express Worldwide Courier & Cargo Pvt.Ltd</h3>

                                <h4>Delhi (Office)</h4>

                                <p>

                                    L-44-A/KH-732, Ground Floor, Near Hotel Royal Inn, Mahipalpur, New Delhi - 110037

                                </p>

                                <p>📞 +91  9975350136 </p>

                                {/* <p>📞 +91  9888880259 </p>

                                <p>📞 Tel .  0161-5010259 </p> */}

                                <p>✉ corporate@expwwc.com</p>

                            </div>

                            {/* COLUMN 3 */}

                            <div className="footer-box">

                                <h3>SERVICES</h3>

                                <ul className="services-list">

                                    <li>Air Ticket Booking</li>

                                    <li>Tour Packages</li>

                                    <li>Tourist Visa Assistance</li>

                                    <li>Money Transfer Services</li>

                                    <li>Airline Consolidation</li>

                                    <li>Port to Port Shipping</li>

                                    <li>Air Cargo</li>

                                    <li>Sea Freight Cargo</li>

                                    <li>Packers and Movers </li>

                                </ul>

                            </div>

                            {/* ✅ NEW COLUMN 4 */}

                            <div className="footer-box">

                                <h3>QUICK LINKS</h3>

                                <ul className="services-list">

                                    <li>Home</li>

                                    <li>About Us</li>

                                    <li>Tracking</li>

                                    <li>Contact</li>

                                    <li>Privacy Policy</li>

                                    <li>Standard Conditions of Carriage</li>

                                    <li>Payment Terms and Conditions</li>

                                    <li>Food Items</li>

                                </ul>

                            </div>

                        </div>

                    </div>

                </footer>

                <div className="footer-bottom">

                    <div className="footer-bottom-container">

                        <div className="footer-left">

                            © 2026 Express Worldwide Courier & Cargo  Logistics All Rights Reserved.

                        </div>

                        <div className="footer-right">

                            <a href="#">Privacy & Policy</a>

                            <a href="#">Terms & Conditions</a>

                            <a

                                href="https://www.futureinfosys.in/"

                                target="_blank"

                                rel="noopener noreferrer"

                                className="developer-credit"

                            >

                                Designed & Developed by Future Infosys Technologies

                            </a>

                        </div>

                    </div>

                </div>

            </div>

        </>

    );

};

export default ExpressWorldTracking;









